const Dictionary = () =>
  import(
    /* webpackChunkName: "system-dictionary-dictionary" */ '@/pages/system/dictionary/dictionaries/index.vue'
  )
const CreateDictionary = () =>
  import(
    /* webpackChunkName: "system-dictionary-dictionary" */ '@/pages/system/dictionary/dictionaries/create.vue'
  )
const EditDictionary = () =>
  import(
    /* webpackChunkName: "system-dictionary-dictionary" */ '@/pages/system/dictionary/dictionaries/edit.vue'
  )

export default {
  path: 'dictionaries',
  meta: {
    label: 'dictionary',
    auth: 'dictionary'
  },
  component: {
    name: 'Dictionary',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemDictDictionary',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Dictionary
    },
    {
      name: 'SystemCreateDictDictionary',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateDictionary
    },
    {
      name: 'SystemEditDictDictionary',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditDictionary,
      props: true
    }
  ]
}
